import React from 'react';
import { Drawer, Typography, Box, IconButton, DrawerProps } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

interface MobileDrawerProps {
  children: React.ReactNode;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  title: string;
  sx?: DrawerProps['sx'];
  dataTestId?: string;
}

const MobileDrawer = ({ children, onClose, open, title, sx, dataTestId }: MobileDrawerProps): JSX.Element => {
  return (
    <Drawer
      open={open}
      onClose={() => onClose(false)}
      anchor="bottom"
      transitionDuration={400}
      sx={sx}
      data-testid={dataTestId}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '50px' }} pl={2} pt={4} pr={2}>
        <IconButton aria-label="close" onClick={() => onClose(false)}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5">{title}</Typography>
      </Box>
      <Box p={2}>{children}</Box>
    </Drawer>
  );
};

export default MobileDrawer;
